export default __webpack_public_path__ + "static/media/Republic1.609e4875.png";